import {
  FormControlLabel,
  Radio as MuiRadio,
  RadioProps as MuiRadioProps,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';

export type LelyRadioButtonProps = Omit<
  MuiRadioProps,
  'checkedIcon' | 'children' | 'icon'
> & {
  'data-testid'?: string;
  children?: ReactNode;
  dense?: boolean;
  label?: ReactNode;
};

function LelyRadioButton({
  children,
  dense,
  label,
  'data-testid': dataTestId,
  ...props
}: LelyRadioButtonProps) {
  const radio = (
    <MuiRadio
      {...props}
      data-dense={dense || undefined}
      data-testid={dataTestId}
    />
  );

  const labelContent = label ?? children;

  if (labelContent) {
    return (
      <FormControlLabel
        control={radio}
        label={
          <Typography
            variant="xs"
            component="span"
            data-testid="radio-label"
            sx={(theme) => ({
              minWidth: 0,
              overflowWrap: 'anywhere',
              fontFamily: theme.lelyFontFamily.UBUNTU,
            })}
          >
            {labelContent}
          </Typography>
        }
      />
    );
  }

  return radio;
}

export default LelyRadioButton;
